<script lang="ts">
    import {
        mouse,
        SettingsWindow,
        Dialogs,
        Notifications,
    } from "@ceyper-common";
    import { COMMANDS } from "$lib/commands";
    import { EditorSettings, GeneralSettings, SETTINGS_PAGES } from "$lib/commands/settings";

    import { createLayout } from "$lib/panels/layout";
    import Zoomable from "$lib/panzoom/Zoomable.svelte";
    import { onMount } from "svelte";
    import Viewer from "$lib/image/Viewer.svelte";
    import Layout from "$lib/layout/Layout.svelte";
    import { file, initialized } from "$lib/state";
    import FunctionOptions from "$lib/panels/FunctionOptions.svelte";


    const layout = createLayout();
    layout.reset();

    let zoomable: Zoomable;
    let container: HTMLDivElement;

    onMount(() => {
        console.log("mounting")
        let stopPan = () => {
        };
        const { add, destroy } = COMMANDS.registerActions("editor");

        add("camera.center", zoomable.centerCamera);

        add("camera.pan", function(this: any) {
            stopPan?.();
            if (this.type === "keydown" || this.type === "mousedown") {
                stopPan = zoomable.startPan($mouse);
            }
        });

        add("camera.zoom-in", () => zoomable.zoomIn($mouse));
        add("camera.zoom-out", () => zoomable.zoomOut($mouse));

        add("camera.zoom-in-center", () => zoomable.zoomInCenter());
        add("camera.zoom-out-center", () => zoomable.zoomOutCenter());

        const { destroy: destroyWindowMouseEvents } = COMMANDS.registerMouseEvents(window);
        const mouseScope = COMMANDS.actions.mouseScope(container, "editor");

        return () => {
            mouseScope.destroy();
            destroyWindowMouseEvents();
            destroy();
        };
    });

    onMount(() => GeneralSettings.subscribe((settings) => {
        document.documentElement.style.setProperty(
            "font-size",
            `${settings["ui-scale"].value}%`,
        );
    }));

    onMount(() => EditorSettings.subscribe((settings) => {
        document.body.style.setProperty(
            "--bgcanvas",
            `${settings["canvas-background"].value}`,
        );
    }));
</script>

<!----------------------------------------------------------------------------->

<Layout>
    <div class="content">
        <Zoomable
            width={$file?.width ?? 32}
            height={$file?.height ?? 32}
            bind:this={zoomable}
            bind:container
            let:state
        >
            {#if $file}
                <Viewer {state} />
            {/if}
        </Zoomable>
        {#if !$file}
            <div class="empty">
                <button on:click={COMMANDS.commands["file.new"].invoke}>No files created, create a new file?</button>
            </div>
        {/if}

        <FunctionOptions />
    </div>
</Layout>

<SettingsWindow
    pages={SETTINGS_PAGES}
    command={{ handler: COMMANDS, id: "general.settings", scope: "all", openScope: "modal" }}
/>

<Dialogs command={{ handler: COMMANDS, openScope: "modal" }} />
<Notifications />

<!----------------------------------------------------------------------------->

<style>
    :global(body) {
        padding: 0;
        margin: 0;
        --bgcanvas: var(--g50);
    }

    :global(.editor-variables) {
        --handle-size: 8px;

        --button-width: 1.75em;
        --button-height: 1.75em;
        --button-margin: 0.25em;

        --min-size: 10em;
        /*--button-hover: #fff2;*/
        /*--button-active: #fff4;*/

        /*--gap-color: var(--bg50);*/
        /*--dragging-color: #265973aa;*/
        /*--panel-bg: var(--bg150);*/
        /*--editor-bg: var(--bg50);*/
    }

    .content {
        height: 100%;
        width: 100%;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 1fr;
        position: relative;
        background: var(--bgcanvas);
    }

    .content > * {
        grid-row: 1;
        grid-column: 1;
    }

    .empty {
        position: absolute;
        inset: 0;
        display: grid;
        place-content: center;

        & button {
            all: unset;
            cursor: pointer;

            &:hover {
                color: var(--tacc);
            }
        }
    }
</style>
